import { SimpleModalService } from '../../shared/dialogs/simple-modal.service'
import { AfterViewInit, Component, Inject } from '@angular/core'
import { NgForm } from '@angular/forms'
import { Router } from '@angular/router'

import { AuthService } from '../../core/auth/auth.service'
import { BuildInfo } from '../../constants/buildInfo.constant'

import { SentryService } from '../../core/monitoring/sentry.service'
import { DialogService } from '../../core/services/dialog.service'
import { PasswordResetDialogComponent } from './dialogs/password-reset-dialog.component'
import { MainDialogService } from '../../core/layout/services/main-dialog.service'
import { CaStateService } from '../../core/services/ca-state.service'
import { CommonConstants } from '../../constants/common.constants'

@Component({
    selector: 'ca-login',
    templateUrl: './login.component.html',
})
export class LoginComponent implements AfterViewInit {

    emailRegex: RegExp = CommonConstants.EMAIL_REGEX
    title = 'Přihlášení'
    username = ''
    countWrongLog = 0
    sending = false
    invalidCredentials = false
    invalidUsernameFormat = false
    serverError = false
    public randomBcgEnabled = false
    appVersion = BuildInfo.appVersion
    buildDate = BuildInfo.buildDate
    private randomBcgStorageName = 'ca_login_alternative_bcg'

    constructor(@Inject(Router) private router: Router,
                @Inject(AuthService) private authService: AuthService,
                @Inject(DialogService) private dialogService: DialogService,
                @Inject(MainDialogService) private mainDialogService: MainDialogService,
                @Inject(SentryService) private sentryService: SentryService,
                @Inject(CaStateService) private caStateService: CaStateService,
                @Inject(SimpleModalService) private simpleModalService: SimpleModalService,
    ) {
    }

    ngAfterViewInit(): void {
        this.randomBcgEnabled = JSON.parse(localStorage.getItem(this.randomBcgStorageName))
        this.initRandomBackground()
    }

    onUsernameBlur(): void {
        this.username = this.username.toLowerCase()
    }

    showPasswordReset(): void {
        this.simpleModalService
            .addModal(PasswordResetDialogComponent, { username: this.username })
            .subscribe((result) => {
                if (result === 'helpdesk') {
                    this.mainDialogService.showHelpdesk()
                    return
                } else if (!result) {
                    return
                }

                this.dialogService.showSuccessDialog(
                    'Požadavek na změnu hesla byl vygenerován a zaslán na Vámi uvedenou emailovou adresu '
                    + result
                    + ' (pokud byla nalezena u nás v databázi).')
            })
    }

    submitCredentials(loginForm: NgForm): void {
        this.onUsernameBlur()
        loginForm.value.username = loginForm.value.username.toLowerCase()
        this.invalidUsernameFormat = false
        if (!this.emailRegex.test(loginForm.value.username)) {
            this.invalidUsernameFormat = true
            return
        }
        this.sending = true
        this.invalidCredentials = false
        this.serverError = false
        this.authService.login(loginForm.value.username, loginForm.value.password, loginForm.value.keep).then(
            (result) => {
                if (result.success === true) {
                    this.resetWrongPassword()
                    this.router.navigate(['/landingPage'])
                } else {
                    this.handleLoginError(result)
                }
            },
        ).catch(error => {
           this.handleLoginError(error)
        })
    }

    public onChangeAlternativeBcg(value: boolean): void {
        localStorage.setItem('ca_login_alternative_bcg', JSON.stringify(value))
        this.randomBcgEnabled = value
        this.initRandomBackground(true)
    }

    private handleLoginError(error): void {
        this.addWrongLog()
        this.sending = false
        // Handle the error
        if (error?.code === 401) {
            this.invalidCredentials = true
        } else {
            this.serverError = true
            const codeText = error?.code != null ? error.code.toString() : 'unknown'
            this.sentryService.captureCustomException(`Login endpoint failed with HTTP ${ codeText }`)
        }
    }

    private addWrongLog(): void {
        this.countWrongLog++

        if (this.countWrongLog >= 3) {
            this.showResetPassword()
        }
    }

    private resetWrongPassword(): void {
        this.countWrongLog = 0
    }

    private showResetPassword(): void {
        this.dialogService
            .showYesNoDialog(
                'Více neúspěšných pokusů o přihlášení',
                ['Zaznamenali jsme několik neúspěšných pokusů o přihlášení. '
                + 'Pokud si nepamatujete heslo, je možné jej změnit skrze emailovou zprávu. '
                + 'Chcete změnit heslo?'],
                'Změnit heslo',
                'Pokračovat bez změny')
            .subscribe((result) => {
                if (result) {
                    this.showPasswordReset()
                }
            })
    }

    private initRandomBackground(resetAble?: boolean): void {
        if (!this.randomBcgEnabled && !resetAble) {
            return
        }
        const images = [
            '../../assets/img/aerial.jpg',
            '../../assets/img/ca_login_panorama_01.jpg',
            '../../assets/img/ca_login_panorama_02.jpg',
            '../../assets/img/ca_login_agro_01.jpg',
            '../../assets/img/ca_login_fall_01.jpg',
            '../../assets/img/ca_login_fall_02.jpg',
            '../../assets/img/ca_login_harvester_01.jpg',
            '../../assets/img/ca_login_harvester_02.jpg',
            '../../assets/img/ca_login_ppl_01.png',
            '../../assets/img/ca_login_worker_01.png',
            '../../assets/img/ca_login_worker_02.png',
            '../../assets/img/ca_login_worker_03.png',
            '../../assets/img/login/ca_login_panorama_03.png',
            '../../assets/img/login/ca_login_panorama_04.png',
            '../../assets/img/login/ca_login_fields_01.png',
            '../../assets/img/login/ca_login_fields_cows_01.png',
        ]

        const randomIndex = this.randomBcgEnabled ? Math.floor(Math.random() * images.length) : 0
        const element = document.getElementsByClassName('loginPage')
        if (element.length > 0) {
            (element[0] as HTMLElement).style.backgroundImage = `url(${images[randomIndex]})`
        }
    }
}